module.exports = __webpack_public_path__ + "static/media/18_esgds.f8825d8d.svg";